export function getNonce(context: any) {
  if (typeof window === 'undefined') {
    return context.req?.headers?.['x-nonce'] || ''
  } else {
    return window.__NEXT_DATA__.props.pageProps?.nonce || ''
  }
}
